import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Components/Form";
import toast from "react-hot-toast";
import Header from "../../../../Components/Header";
import {
  create_team,
  get_team,
  update_team,
} from "../../../../Controllers/Contacts/Teams";
import forms from "../../../../Data/Forms/Contacts/Teams/forms";
import headers from "../../../../Data/Forms/Contacts/Teams/headers";
import Loadercomponent from "../../../../Components/Loader";
import AddButton from "../../../../Components/Buttons/add";
import RemoveButton from "../../../../Components/Buttons/delete";
import { convert_to_file } from "../../../../Controllers/Global";

const ContactTeamsForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const team = id
        ? await update_team({ ...data?.data, id: id })
        : await create_team(data?.data);

      if (team?.status) {
        if (id) {
          navigate(-1);
        }
        toast?.success(team?.message);
        setButtonLoader(false);
      } else {
        toast?.error(team?.message);
        setButtonLoader(false);
      }
    }
  };

  const handleData = async (team) => {
    let image = team?.image ? team?.image : "";
    let file = await convert_to_file(image);
    let name = team?.name ? team?.name : "";
    let designation = team?.designation ? team?.designation : "";
    let phone = team?.phone ? team?.phone : "";
    let email = team?.email ? team?.email : "";
    let description = team?.description ? team?.description : "";
    let status = team?.status ? team?.status : 0;

    values[0].options[0].form.value = [file];
    values[0].options[1].form.value = name;
    values[0].options[2].form.value = designation;
    values[0].options[3].form.value = phone;
    values[0].options[4].form.value = email;
    values[0].options[5].form.value = description;
    values[0].options[6].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const team = await get_team(data);
      if (team?.status) {
        handleData(team?.data);
      } else {
        toast?.error(team?.message);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={headers}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ContactTeamsForm;
